import React from "react";
import { TypographyInspector } from "./inspectors/TypographyInspector";
import { findNodeById } from "../NodeUtils";
import { useSelection } from "../ElementRenderer/SelectionContext";
import { SpacingInspector } from "./inspectors/SpacingInspector";

export function InspectorPanel({ page, setPage }) {
  const { selectedNodeId } = useSelection();
  if (!selectedNodeId) return null;

  const result = findNodeById(page, selectedNodeId);
  if (!result) return null;

  const { level } = result;

  return (
    <aside style={{
      width: 320,
      background: "#fff",
      borderLeft: "1px solid #e1e4e8",
      padding: 16,
      position: "fixed",
      left: 0,
      top: 0,
      height: "100vh",
      overflowY: "auto",
    }}>
      <h3 style={{ marginBottom: 12 }}>Inspector</h3>

      {level === "element" && (
  <>
    <TypographyInspector page={page} setPage={setPage} result={result} />
    <SpacingInspector page={page} setPage={setPage} result={result} />
  </>
)}

{level === "card" && (
  <SpacingInspector page={page} setPage={setPage} result={result} />
)}

{level === "container" && (
  <SpacingInspector page={page} setPage={setPage} result={result} />
)}

{level === "section" && (
  <SpacingInspector page={page} setPage={setPage} result={result} />
)}

      {/* Later:
       {level === "card" && <CardInspector .../>}
       {level === "container" && <ContainerInspector .../>}
       {level === "section" && <SectionInspector .../>}
      */}
    </aside>
  );
}
